import { CmsApplianceDetailsSteppedBenefitsPanel } from '../appliance-details-stepped-benefits-panel/cms-appliance-details-stepped-benefits-panel.interface';
import { CmsRegistrationRoot } from '../cms/cms-registration-root.interface';
import { CmsProtectionUpsellPanel } from '../protection-upsell/cms-protection-upsell-panel.interface';
import { CmsApplianceDetailsSteppedForm } from './cms-appliance-details-stepped-form.interface';

export interface CmsApplianceDetailsSteppedPage
  extends CmsRegistrationRoot,
    CmsApplianceDetailsSteppedForm,
    CmsProtectionUpsellPanel {
  applianceDetailsSteppedBenefitsPanel: CmsApplianceDetailsSteppedBenefitsPanel;
  pagePanel?: string;
}
